
const getBlackbox = () =>
    new Promise(resolve => {
        
        if (window.io_loaded) {
            resolve(window.ioGetBlackbox().blackbox);
        }
        
        
        window.io_enable_rip = true;
        window.io_install_stm = false;
        window.io_install_flash = false;
        
        window.io_bb_callback = ( (blackbox, isComplete) => {
                if (!isComplete) {
                    return;
                }
                window.io_loaded = true;
                resolve(blackbox);
            }
        );
        
        const scriptEl = document.createElement('script');
        scriptEl.src = 'https://mpsnare.iesnare.com/snare.js';
        document.body.appendChild(scriptEl);
    });

export default getBlackbox;
